import { AppState } from '../../init/rootReducer';
import { ForgottenPasswordPageState } from './reducer';

const getForgottenPasswordPageState = (state: AppState): ForgottenPasswordPageState =>
  state.containers.forgottenPassword;

export default getForgottenPasswordPageState;
